<template>
  <i :class="nameClass"></i>
  <!-- <svg :class="className">
    <use :xlink:href="'#' + name"></use>
  </svg> -->
</template>

<script>
export default {
  props: [
    'name'
  ],
  computed: {
    nameClass () {
      return 'icon ' + this.name
    }
  }
}
</script>

<style>

</style>
